import React, { createContext, useContext } from 'react';

export type HandleError = (
  error: CustomHttpError | string,
  componentStack?: string,
) => void;

// eslint-disable-next-line no-console
const SendErrorContext = createContext(console.error);

export const SendErrorProvider = ({
  value,
  children,
}: {
  value: HandleError;
  children: JSX.Element;
}): JSX.Element => (
  <SendErrorContext.Provider value={value}>
    {children}
  </SendErrorContext.Provider>
);

export const useSendError = (): HandleError => useContext(SendErrorContext);
